"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return value;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/identity.js
// module id = 503
// module chunks = 0